import React, { Component } from "react";
import "./styles/css/style.css";
import ReactHtmlParser from "react-html-parser";
class Alert extends Component {
  componentWillMount() {}
  render() {
    return (
      <div className="region region-emergency">
        <div
          id={"block-" + this.props.type + "-details"}
          className={
            "block block-" +
            this.props.type +
            " contextual-links-region first odd"
          }
        >
          <h2 className="block__title block-title">
            {this.props.title}
          </h2>

          <p>
            {ReactHtmlParser(this.props.message)}
          </p>
        </div>
        <div
          id={"block-" + this.props.type + "-summary"}
          className={
            "block block-" + this.props.type + " contextual-links-region even"
          }
        >
          <a href={this.props.linkto}>
            {this.props.title}
          </a>
        </div>
        {this.props.more !== null
          ? <div
              id={"block-" + this.props.type + "-additional"}
              className={
                "block block-" +
                this.props.type +
                " contextual-links-region odd"
              }
            >
              {ReactHtmlParser(this.props.more)}
            </div>
          : null}
      </div>
    );
  }
}

export default Alert;
